import { Container } from "components/layout/Container";
import { FAQItemFiltered } from "components/pages/faq/FAQItemFiltered";
import styles from "./FilteredContent.module.scss";

type FilteredContentProps = {
  list: {
    id: string;
    heading: string;
    content: string;
  }[];
};

export const FilteredContent = ({ list }: FilteredContentProps) => {
  return (
    <Container>
      <div className={styles.inner}>
        <div className={styles.list}>
          {list.map(({ id, ...rest }) => (
            <FAQItemFiltered key={id} id={id} {...rest} className={styles.item} />
          ))}
        </div>
      </div>
    </Container>
  );
};
